module.exports = __webpack_public_path__ + "static/cummings-710459a8e786478f91dd8590baad485f.jpg";